import sortBy from 'lodash/sortBy';
import Vue from "vue";
import { http } from '../../http';
import omit from "lodash/omit";

export default {
    state: {
        events: [],
        loaded: false,
        loading: false
    },

    getters: {
        all: (state) => {
            return sortBy(state.events, 'name');
        },

        isLoaded: (state, getters) => {
            return state.loaded;
        }
    },

    mutations: {
        add: (state, event) => {
            state.events.push(event);
        },

        update: (state, event) => {
            const eventIndex = _.findIndex(state.events, { 'id': event.id });

            if (eventIndex != -1) {
                Vue.set(state.events, eventIndex, event);
            } else {
                state.events.push(event);
            }
        },

        delete: (state, event) => {
            state.events = state.events.filter(c => c.id !== event.id);
        },

        setEvents(state, data) {
            state.events = data.data;
        },

        setLoaded(state) {
            Vue.set(state, 'loaded', true);
        }
    },

    actions: {
        loadEvents(context) {
            if (context.loaded || context.loading) {
                return;
            }

            http.get('/app/events/active')
                .then(({ data }) => {
                    context.commit('setEvents', data);
                    context.loading = false;
                    context.commit('setLoaded');
                });
        },

        loadData(context) {
            context.dispatch('loadEvents');
        },
    }
}